<template>
    <div :class="`DshSelect ycFormItem control-${mode}`">
        <!-- // optionKind值 'flat'、'dropdown' -->
        <!-- <template
            v-if="canEdit"> -->
        <!-- 平铺 -->
        <RadioGroup
            v-if="['flat', 'button'].includes(selfPropsObj._optionKind)"
            :class="[
                    'DshSelect-radioGroup',
                    {
                        'DshSelect-radioGroup-useColor': selfPropsObj._useColor,
                        'DshSelect-radioGroup-readonly': $isReadonly(canEdit, selfPropsObj),
                        'DshSelect-radioGroup-disabled': $isDisabled(canEdit, selfPropsObj)
                    }
                ]"
            v-model="value[selfPropsObj._key]"
            :type="selfPropsObj._optionKind === 'button' ? 'button' : undefined"
            @on-change="change"
        >
            <template v-if="listData.length">
                <Radio
                    v-for="(item, index) in listData"
                    :key="index"
                    :label="item._key"
                    :style="{
                            backgroundColor: selfPropsObj._useColor ? item.color : undefined
                        }"
                    :border="selfPropsObj._useColor"
                    :disabled="!finalCanEdit || item._disabled"
                    @click.native="cancelSelect(item)"
                >
                    {{ item.name || item._name }}
                </Radio>
            </template>

            <div
                v-else
                class="dsh-subtip"
                style="backgroundColor: #f3f3f3;"
            >-- 无选择项 --</div>
        </RadioGroup>

        <!-- 下拉 -->
        <Select
            v-else
            v-model="value[selfPropsObj._key]"
            :class="{
                    'DshSelect-select-readonly': $isReadonly(canEdit, selfPropsObj),
                    'DshSelect-select-disabled': $isDisabled(canEdit, selfPropsObj)
                }"
            :placeholder="$showPlaceholder(canEdit, selfPropsObj) ? `请选择${selfPropsObj._name}` : ''"
            :multiple="selfPropsObj._multiple"
            :disabled="!finalCanEdit"
            :clearable="clearable"
            :filterable="selfPropsObj._filterable"
            :transfer="true"
            :size="selfPropsObj._size"
            @on-change="change"
        >
            <Icon
                v-if="selfPropsObj._prefix && listData.find(item => item._key === value[selfPropsObj._key]).icon"
                class="DshSelect-select-prefix"
                slot="prefix"
                :custom="`bico-font ${listData.find(item => item._key === value[selfPropsObj._key]).icon || listData[0].icon}`"
                size="20"
            />
            <Option
                v-for="(item, index) in listData"
                :key="index"
                :value="item._key"
                :disabled="item._disabled"
            >
                <Icon
                    :custom="`bico-font ${item.icon}`"
                    :color="item.color"
                    :size="item.size || 20"
                />
                {{ item.name || item._name }}
            </Option>
        </Select>
        <!-- </template>

        <Ctooltip v-else
            placement="top"
            :transfer="true"
            class="DshSelect-tooltip"
         >
            <span slot="content">
                {{ data.name || value[selfPropsObj._key] }}
            </span>
            <div style="width:100%;text-align:center;">
                <span class="dsh-ellipsis DshSelect-content"
                    :style='{
                        background: selfPropsObj._useColor ? data.color : "",
                        color: selfPropsObj._useColor ? "#fff" : ""
                    }'>
                    {{  data.name || value[selfPropsObj._key]}}
                </span>
            </div>
        </Ctooltip> -->

        <!-- tip项弹框提示 -->
        <dsh-render :render="tipModalRender"></dsh-render>
    </div>
</template>

<script>
    import controlMixin from "../controlMixin.js";
    import selectMixin from "./selectMixin.js";

    export default {
        name: "DshSelect",
        mixins: [controlMixin, selectMixin],
        props: {},
        data () {
            return {
                flag: false,
                initListData: []
            };
        },
        computed: {
            selfPropsObj () {
                return {
                    _filterable: false,
                    ...this.propsObj
                };
            },
            listData () {
                const listData = (this.selfPropsObj._data || []).concat(this.initListData);
                if (this.$dataType(this.selfPropsObj._filterFunc, "function")) {
                    return this.selfPropsObj._filterFunc(listData, this.selfPropsObj, this.value);
                } else {
                    return listData;
                }
            }
            // data () {
            //     return (this.listData.find(item => item._key === this.value[this.selfPropsObj._key]) || {});
            // }
        },
        created () {
            this.initData();
        },
        methods: {
            initData () {
                if (this.selfPropsObj._customData && this.selfPropsObj._customData.length) {
                    this.selfPropsObj._customData.forEach(item => {
                        this.getListData(item);
                    });
                }
            },
            getListData (_customData) {
                this.$https({
                    url: _customData.url,
                    params: {
                        ..._customData.params
                    },
                    callback: data => {
                        this.initListData.push(...data.list.map(item => (
                            {
                                _key: item[_customData._key || "_key"],
                                name: item[_customData._name || "name"]
                            }
                        )));
                    }
                });
            },
            // 取消flat模式的选择项
            cancelSelect (item) {
                if (this.selfPropsObj._clearable !== false) {
                    if (item._key === this.value[this.selfPropsObj._key]) {
                        this.value[this.selfPropsObj._key] = "";

                        this.change();
                    }
                }
                this.clickOpenTip(item);
            },
            change (...params) {
                // 修复clear后值为undefined，不触发更新
                if (this.value[this.selfPropsObj._key] == undefined) this.value[this.selfPropsObj._key] = "";

                this.$emit("change", this.value[this.selfPropsObj._key]);
            }
        }
    };
</script>



// WEBPACK FOOTER //
// node_modules/bri-vtools/src/components/controls/base/DshSelect.vue